import { action } from 'typesafe-actions';
import { DashboardActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const updateTeamSelection = (data): any => action(types.UPDATE_DASHBOARD_CONFIG, { teamSelection: data });
export const updateSeasonSelection = (data): any => action(types.UPDATE_DASHBOARD_CONFIG, { seasonSelection: data });

export const hideUpcomingMatches = (): any => action(types.UPDATE_DASHBOARD_CONFIG, { hideUpcomingMatches: true });
export const showUpcomingMatches = (): any => action(types.UPDATE_DASHBOARD_CONFIG, { hideUpcomingMatches: false });

export default null;
